import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorModel } from '../../../models/error.model';
import { ErrorTypes } from '../../error-types.enum';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-site-error',
  standalone: false,
  templateUrl: './site-error.component.html',
  styleUrls: ['./site-error.component.scss'],
})
export class SiteErrorComponent implements OnInit {
  error: ErrorModel;

  constructor(private route: ActivatedRoute, private authService: AuthService) { }

  ngOnInit(): void {
    this.error = history.state;

    console.error(JSON.stringify(this.error));

    if (this.error.errorType == ErrorTypes.LoginError) this.login();
  }

  retry() {
    window.location.href = '/';
  }

  login() {
    window.location.href = '/';
  }

  /**
 * Calls the logout service.
 *
 * @returns void
 */
  logout(): void {
    this.authService.logout();
  }
}
